import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Tables } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import RemoveModal from 'components/PromptModal/PromptModal';

const { TableCell, TableRow } = Tables;
const { Link } = RouterProvider;

interface TemplateProps {
  name: string | null;
  active: boolean | null;
  id: number;
  singleUrl: string;
  removeTemplate: (id: number) => void;
}

const Template = ({
  name,
  active,
  id,
  singleUrl,
  removeTemplate,
}: TemplateProps) => {
  const t = useFormatMessage();

  return (
    <>
      <TableRow>
        <TableCell>{name}</TableCell>
        <TableCell>
          {active && t('dashboard.templates.active', 'Active')}
        </TableCell>
        <TableCell align="right">
          <Link to={`${singleUrl}/${id}/edit`}>
            <Tooltip
              title={t('tooltip.organizations.edit', 'Edit template')}
              placement="top"
            >
              <EditIcon />
            </Tooltip>
          </Link>
          <Tooltip
            title={t('tooltip.organizations.delete', 'Delete template')}
            placement="top"
          >
            <RemoveModal
              onConfirm={() => removeTemplate(id)}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              <>
                {t(
                  'pages.template.modal.remove',
                  'Are you sure you want to remove template { name }',
                  {
                    name,
                  }
                )}
              </>
            </RemoveModal>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  );
};

export default Template;
